// import React from "react";
// import { CityDropdownForTrip, CommonDatePicker, CommonInput } from "components";

// const LoadFormFields = ({ load, setLoads, fetchConsignorList, fetchCityList, onEwayInputClick, masterData ,onEwayBillNumberChange,   
//   onEwayStartDateChange,    
//   onEwayExpiryDateChange,   }) => {
//   const errors = load.errors || {};

//   const update = (field, value) =>
//     setLoads((prev) =>
//       prev.map((l) =>
//         l.id === load.id
//           ? { ...l, [field]: value, errors: { ...l.errors, [field]: "" } }
//           : l
//       )
//     );

//   const handleNumericInput = (field, value) => {
//     if (!/^\d*\.?\d*$/.test(value)) return;
//     let formattedValue = value;
//     if (value.includes(".")) {
//       const [integer, decimal] = value.split(".");
//       formattedValue = `${integer}.${decimal.substring(0, 2)}`;
//     }
//     update(field, formattedValue);
//   };

//   const handleKeyDown = (e, field) => {
//     if (field === "quantity") {
//       if (["E", "e", "-", "+", "."].includes(e.key)) e.preventDefault();
//     } else {
//       if (["E", "e", "-", "+"].includes(e.key)) e.preventDefault();
//     }
//   };

//   return (
//     <>
//       {/* Eway Row */}
//       <div className='load-form-row eway-row with-box-bg'>
//         <div className="form-field" style={{ flex: '9.5%' }}>
//           <div
//             onClick={!load.ewayFetchLoading ? onEwayInputClick : undefined}
//             style={{ cursor: load.ewayFetchLoading ? "not-allowed" : "pointer", maxWidth: load.ewayBillNumber ? '' : '39%', width: '100%' }}
//           >
//             <CommonInput
//             label="Eway Bill Number"
//             placeholder="Eway Bill Number"
//             // ✅ Controlled — read from load state
//             value={load.ewayBillNumber || ""}
//             onChange={({ target: { value } }) => {
//               // ✅ Update via parent handler OR direct setLoads
//               if (onEwayBillNumberChange) {
//                 onEwayBillNumberChange(value);
//               } else {
//                 setLoads(prev =>
//                   prev.map(l =>
//                     l.id === load.id
//                       ? { ...l, ewayBillNumber: value, errors: { ...l.errors, ewayBillNumber: "" } }
//                       : l
//                   )
//                 );
//               }
//             }}
//             error={load.errors?.ewayBillNumber}
//             focus={!!load.errors?.ewayBillNumber}
//             maxLength={12}
//             />
//           </div>
//         </div>

//         {load.ewayBillNumber && (
//           <>
//             <div className="form-field">
//               <CommonDatePicker
//                 label="Eway Start Date"
//             placeholder="Eway Bill Start Date"
//             // ✅ Controlled from load state
//             startDate={load.ewayStartDate || null}
//             setStartDate={(val) => {
//               if (onEwayStartDateChange) {
//                 onEwayStartDateChange(val);
//               } else {
//                 setLoads(prev =>
//                   prev.map(l =>
//                     l.id === load.id
//                       ? { ...l, ewayStartDate: val, errors: { ...l.errors, ewayStartDate: "" } }
//                       : l
//                   )
//                 );
//               }
//             }}
//             error={load.errors?.ewayStartDate}
//             focus={!!load.errors?.ewayStartDate}
//             id={`eway-start-${load.id}`}
//             maxDate={new Date()}
//               />
//             </div>
//             <div className="form-field">
//               <CommonDatePicker
//                label="Eway End Date"
//             placeholder="Eway Bill Expiry Date"
//             // ✅ Controlled from load state
//             startDate={load.ewayExpiryDate || null}
//             setStartDate={(val) => {
//               if (onEwayExpiryDateChange) {
//                 onEwayExpiryDateChange(val);
//               } else {
//                 setLoads(prev =>
//                   prev.map(l =>
//                     l.id === load.id
//                       ? { ...l, ewayExpiryDate: val, errors: { ...l.errors, ewayExpiryDate: "" } }
//                       : l
//                   )
//                 );
//               }
//             }}
//             minDate={load.ewayStartDate}
//             error={load.errors?.ewayExpiryDate}
//             focus={!!load.errors?.ewayExpiryDate}
//             id={`eway-end-${load.id}`}
//             showTimeSelect={false}
//             defaultTimeFix={true}
//               />
//             </div>
//           </>
//         )}
//       </div>

//       {/* Party + Location Row */}
//       <div className="load-form-row party-row">
//         <div className="form-field">
//           <CityDropdownForTrip
//             placeholder="Select Party *"
//             fetchData={fetchConsignorList}
//             pageSize={20}
//             onChange={(val) => update("party", val)}
//             selectedItem={load.party || null}
//             error={!!errors.party}
//             errorMessage={errors.party}
//           />
//         </div>
//         <div className="form-field">
//           <CityDropdownForTrip
//             placeholder="From Location *"
//             fetchData={fetchCityList}
//             pageSize={20}
//             onChange={(val) => update("fromLocation", val)}
//             selectedItem={load.fromLocation || null}
//             error={!!errors.fromLocation}
//             errorMessage={errors.fromLocation}
//           />
//         </div>
//         <div className="form-field">
//           <CityDropdownForTrip
//             placeholder="To Location *"
//             fetchData={fetchCityList}
//             pageSize={20}
//             onChange={(val) => update("toLocation", val)}
//             selectedItem={load.toLocation || null}
//             error={!!errors.toLocation}
//             errorMessage={errors.toLocation}
//           />
//         </div>
//         <div className="form-field">
//           <CommonInput
//             placeholder="MLR Number"
//             value={load.mlrNumber || ""}
//             onChange={({ target: { value } }) => update("mlrNumber", value)}
//             maxLength={12}
//           />
//         </div>
//         <div className="form-field">
//           <CommonInput
//             placeholder="Invoice Number"
//             value={load.invoiceNumber || ""}
//             onChange={({ target: { value } }) => update("invoiceNumber", value)}
//             maxLength={12}
//           />
//         </div>
//       </div>

//       {/* Item Details Row */}
//       <div className="load-form-row details-row">

//         {/* Product Description */}
//         <div className="form-field">
//           <CommonInput
//             type="text"
//             placeholder="Description"
//             value={load.productDescription || ""}
//             maxLength={100}
//             onChange={({ target: { value } }) => update("productDescription", value)}
//           />
//         </div>

//         {/* ✅ Weight — inline weight_type select */}
//         <div className="form-field">
//           <div style={{
//             display: "flex",
//             alignItems: "center",
//             border: "1px solid #d1d5db",
//             borderRadius: "6px",
//             overflow: "hidden",
//             background: "#fff",
//           }}>
//             <input
//               type="number"
//               placeholder="Weight"
//               value={load.weight > 0 ? load.weight : ""}
//               maxLength={8}
//               onFocus={(e) => e.target.addEventListener("wheel", (e) => e.preventDefault(), { passive: false })}
//               onKeyDown={(e) => handleKeyDown(e, "weight")}
//               onChange={({ target: { value } }) => handleNumericInput("weight", value)}
//               style={{
//                 flex: 1,
//                 border: "none",
//                 outline: "none",
//                 boxShadow: "none",
//                 background: "transparent",
//                 padding: "8px 10px",
//                 fontSize: "13px",
//                 color: "#111827",
//                 minWidth: 0,
//               }}
//             />
//             <select
//               value={load.weight_type || 1}
//               onChange={({ target: { value } }) => update("weight_type", +value)}
//               style={{
//                 border: "none",
//                 borderLeft: "1px solid #e5e7eb",
//                 background: "#f9fafb",
//                 outline: "none",
//                 fontSize: "11px",
//                 color: "#374151",
//                 padding: "0 20px 0 6px",
//                 minHeight: "43px",
//                 minWidth: "52px",
//                 maxWidth: "64px",
//                 cursor: "pointer",
//                 appearance: "none",
//                 WebkitAppearance: "none",
//                 backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'%3E%3Cpath d='M1 1l4 4 4-4' stroke='%236b7280' stroke-width='1.5' fill='none' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E")`,
//                 backgroundRepeat: "no-repeat",
//                 backgroundPosition: "right 4px center",
//               }}
//             >
//               {masterData?.material_weight_type_list?.map((el, idx) => (
//                 <option key={idx} value={el?.id}>{el?.name}</option>
//               ))}
//             </select>
//           </div>
//         </div>

//         {/* ✅ Quantity — inline qty_type select */}
//         <div className="form-field">
//           <div style={{
//             display: "flex",
//             alignItems: "center",
//             border: "1px solid #d1d5db",
//             borderRadius: "6px",
//             overflow: "hidden",
//             background: "#fff",
//           }}>
//             <input
//               type="number"
//               placeholder="QTY"
//               value={load.quantity > 0 ? load.quantity : ""}
//               maxLength={8}
//               onFocus={(e) => e.target.addEventListener("wheel", (e) => e.preventDefault(), { passive: false })}
//               onKeyDown={(e) => handleKeyDown(e, "quantity")}
//               onChange={({ target: { value } }) => handleNumericInput("quantity", value)}
//               style={{
//                 flex: 1,
//                 border: "none",
//                 outline: "none",
//                 boxShadow: "none",
//                 background: "transparent",
//                 padding: "8px 10px",
//                 fontSize: "13px",
//                 color: "#111827",
//                 minWidth: 0,
//               }}
//             />
//             <select
//               value={load.qty_type || 1}
//               onChange={({ target: { value } }) => update("qty_type", +value)}
//               style={{
//                 border: "none",
//                 borderLeft: "1px solid #e5e7eb",
//                 background: "#f9fafb",
//                 outline: "none",
//                 fontSize: "11px",
//                 color: "#374151",
//                 padding: "0 20px 0 6px",
//                 minHeight: "43px",
//                 minWidth: "52px",
//                 maxWidth: "64px",
//                 cursor: "pointer",
//                 appearance: "none",
//                 WebkitAppearance: "none",
//                 backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'%3E%3Cpath d='M1 1l4 4 4-4' stroke='%236b7280' stroke-width='1.5' fill='none' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E")`,
//                 backgroundRepeat: "no-repeat",
//                 backgroundPosition: "right 4px center",
//                 borderRadius: 0
//               }}
//             >
//               {masterData?.material_qty_type_list?.map((el, idx) => (
//                 <option key={idx} value={el?.id}>{el?.name}</option>
//               ))}
//             </select>
//           </div>
//         </div>

//         {/* Sales Value */}
//         <div className="form-field">
//           <CommonInput
//             type="number"
//             placeholder="Amount (₹)"
//             value={load.salesValue > 0 ? load.salesValue : ""}
//             maxLength={10}
//             onFocus={(e) => e.target.addEventListener("wheel", (e) => e.preventDefault(), { passive: false })}
//             onKeyDown={(e) => handleKeyDown(e, "salesValue")}
//             onChange={({ target: { value } }) => handleNumericInput("salesValue", value)}
//           />
//         </div>

//         {/* KOT */}
//         <div className="form-field">
//           <CommonInput
//             type="number"
//             placeholder="KOT"
//             value={load.kot > 0 ? load.kot : ""}
//             maxLength={8}
//             onFocus={(e) => e.target.addEventListener("wheel", (e) => e.preventDefault(), { passive: false })}
//             onKeyDown={(e) => handleKeyDown(e, "kot")}
//             onChange={({ target: { value } }) => handleNumericInput("kot", value)}
//           />
//         </div>

//       </div>
//     </>
//   );
// };

// export default LoadFormFields;


import React, { useState } from "react";
import { CommonDatePicker, CommonInput } from "components";
import DropdownSelectButton from "components/DropdownSelectButton/DropdownSelectButton";
import DropdownSelectModal from "components/DropdwonSelectModal/DropdownSelectModal";
import { createPortal } from "react-dom";

const LoadFormFields = ({
  load,
  setLoads,
  fetchConsignorList,
  fetchCityList,
  onEwayInputClick,
  masterData,
  onEwayBillNumberChange,
  onEwayStartDateChange,
  onEwayExpiryDateChange,
  onAddNewParty = null,
  onEditParty = null,
  onAddNewFromLocation = null,
  onEditFromLocation = null,
  onAddNewToLocation = null,
  onEditToLocation = null,
}) => {
  const errors = load.errors || {};

  // ─── Modal state for party, from, to ─────────────────────────────────────
  const [partyModal, setPartyModal] = useState({ action: false });
  const [fromModal, setFromModal] = useState({ action: false });
  const [toModal, setToModal] = useState({ action: false });

  // ─── Core update helper ───────────────────────────────────────────────────
  const update = (field, value) =>
    setLoads((prev) =>
      prev.map((l) =>
        l.id === load.id
          ? { ...l, [field]: value, errors: { ...l.errors, [field]: "" } }
          : l
      )
    );

  // const handleNumericInput = (field, value) => {
  //   if (!/^\d*\.?\d*$/.test(value)) return;
  //   let formattedValue = value;
  //   if (value.includes(".")) {
  //     const [integer, decimal] = value.split(".");
  //     formattedValue = `${integer}.${decimal.substring(0, 2)}`;
  //   }
  //   update(field, formattedValue);
  // };

const handleNumericInput = (field, value, maxLen = 10) => {
  // ✅ Length check pehle
  if (value.length > maxLen) return;
  
  if (!/^\d*\.?\d*$/.test(value)) return;
  let formattedValue = value;
  if (value.includes(".")) {
    const [integer, decimal] = value.split(".");
    formattedValue = `${integer}.${decimal.substring(0, 2)}`;
  }
  update(field, formattedValue);
};

  const handleKeyDown = (e, field) => {
    if (field === "quantity") {
      if (["E", "e", "-", "+", "."].includes(e.key)) e.preventDefault();
    } else {
      if (["E", "e", "-", "+"].includes(e.key)) e.preventDefault();
    }
  };

  // ─── fetchListFn adapters ─────────────────────────────────────────────────
  // DropdownSelectModal expects: (search, offset, limit) => { list, hasMore }
  // fetchConsignorList returns:  { items, total }
  const partyFetchFn = async (search, offset, limit) => {
    const res = await fetchConsignorList(search, offset, limit);
    const items = res?.items || [];
    return {
      list: items.map((el) => ({
        ...el,
        label: el?.label || el?.name || "",
        value: el?.value || el?._id,
        subTexts: [el?.firm_id?.firm || ""].filter(Boolean),
      })),
      hasMore: items.length === limit,
    };
  };

  // fetchCityList returns { items, total }
  const cityFetchFn = async (search, offset, limit) => {
    const res = await fetchCityList(search, offset, limit);
    const items = res?.items || [];
    return {
      list: items.map((el) => ({
        ...el,
        // label: el?.label || `${el?.name}, ${el?.stateName}` || "",
        label: `${el?.name}` || "",

        value: el?.value || el?._id || el?.name,
        subTexts: [el?.stateName || ""].filter(Boolean),
      })),
      hasMore: items.length === limit,
    };
  };

  // ─── Display text for city button (City, State) ───────────────────────────
  const cityDisplayTxt = (loc) =>
    loc?.name
      ? `${loc.name}${loc.stateName ? `, ${loc.stateName}` : ""}`
      : "";

  // ─── Build isOpen config for each modal ───────────────────────────────────
  const partyIsOpen = {
    ...partyModal,
    type: "party",
    name: "Party",
    data: load.party || {},
    showAddNew: !!onAddNewParty,
    onAddNew: onAddNewParty || undefined,
    onEdit: onEditParty || undefined,
  };

  const fromIsOpen = {
    ...fromModal,
    type: "fromLocation",
    name: "From Location",
    data: load.fromLocation || {},
    showAddNew: !!onAddNewFromLocation,
    onAddNew: onAddNewFromLocation || undefined,
    onEdit: onEditFromLocation || undefined,
  };

  const toIsOpen = {
    ...toModal,
    type: "toLocation",
    name: "To Location",
    data: load.toLocation || {},
    showAddNew: !!onAddNewToLocation,
    onAddNew: onAddNewToLocation || undefined,
    onEdit: onEditToLocation || undefined,
  };

  // ─── Common modal props factory ───────────────────────────────────────────
  const makeModalProps = (isOpen, closeModal, type, fetchFn, onSelect) => ({
    isOpen,
    closeModal,
    onSubmit: (data) => {
      const selected = data?.[type];
      if (selected) onSelect(selected);
      closeModal({});
    },
    modalMainClass: "_dashCommon_Modal _mdModal __updateListModal",
    headerPart: true,
    floatCrossBtn: true,
    modalTitle: isOpen?.name || "",
    footerPart: true,
    hideFooterSumbmitBtn: true,
    hideCompletelyFoolter: true,
    fetchListFn: fetchFn,
  });

  // ─── Party modal props ────────────────────────────────────────────────────
  // const partyModalProps = makeModalProps(
  //   partyModal,
  //   () => setPartyModal({ action: false }),
  //   "party",
  //   partyFetchFn,
  //   (selected) => update("party", selected),
  // );

  // // ─── From location modal props ────────────────────────────────────────────
  // const fromModalProps = makeModalProps(
  //   fromModal,
  //   () => setFromModal({ action: false }),
  //   "fromLocation",
  //   cityFetchFn,
  //   (selected) => update("fromLocation", selected),
  // );

  // // ─── To location modal props ──────────────────────────────────────────────
  // const toModalProps = makeModalProps(
  //   toModal,
  //   () => setToModal({ action: false }),
  //   "toLocation",
  //   cityFetchFn,
  //   (selected) => update("toLocation", selected),
  // );

  const partyModalProps = makeModalProps(
    partyIsOpen,   // ← use partyIsOpen — has showAddNew, onAddNew, onEdit
    () => setPartyModal({ action: false }),
    "party",
    partyFetchFn,
    (selected) => update("party", selected),
  );

  const fromModalProps = makeModalProps(
    fromIsOpen,    // ← use fromIsOpen
    () => setFromModal({ action: false }),
    "fromLocation",
    cityFetchFn,
    (selected) => update("fromLocation", selected),
  );

  const toModalProps = makeModalProps(
    toIsOpen,      // ← use toIsOpen
    () => setToModal({ action: false }),
    "toLocation",
    cityFetchFn,
    (selected) => update("toLocation", selected),
  );

  return (
    <>
      {/* ── Eway Row ───────────────────────────────────────────────────────── */}
      <div className="load-form-row eway-row with-box-bg">
        <div className="form-field" style={{ flex: "9.5%" }}>
          <div
            onClick={!load.ewayFetchLoading ? onEwayInputClick : undefined}
            style={{
              cursor: load.ewayFetchLoading ? "not-allowed" : "pointer",
              maxWidth: load.ewayBillNumber ? "" : "39%",
              width: "100%",
            }}
          >
            <CommonInput
              label="Eway Bill Number"
              placeholder="Eway Bill Number"
              value={load.ewayBillNumber || ""}
              onChange={({ target: { value } }) => {
                if (onEwayBillNumberChange) {
                  onEwayBillNumberChange(value);
                } else {
                  setLoads((prev) =>
                    prev.map((l) =>
                      l.id === load.id
                        ? { ...l, ewayBillNumber: value, errors: { ...l.errors, ewayBillNumber: "" } }
                        : l
                    )
                  );
                }
              }}
              error={load.errors?.ewayBillNumber}
              focus={!!load.errors?.ewayBillNumber}
              maxLength={12}
            />
          </div>
        </div>

        {load.ewayBillNumber && (
          <>
            <div className="form-field">
              <CommonDatePicker
                label="Eway Start Date"
                placeholder="Eway Bill Start Date"
                startDate={load.ewayStartDate || null}
                setStartDate={(val) => {
                  if (onEwayStartDateChange) {
                    onEwayStartDateChange(val);
                  } else {
                    setLoads((prev) =>
                      prev.map((l) =>
                        l.id === load.id
                          ? { ...l, ewayStartDate: val, errors: { ...l.errors, ewayStartDate: "" } }
                          : l
                      )
                    );
                  }
                }}
                error={load.errors?.ewayStartDate}
                focus={!!load.errors?.ewayStartDate}
                id={`eway-start-${load.id}`}
                maxDate={new Date()}
              />
            </div>
            <div className="form-field">
              <CommonDatePicker
                label="Eway End Date"
                placeholder="Eway Bill Expiry Date"
                startDate={load.ewayExpiryDate || null}
                setStartDate={(val) => {
                  if (onEwayExpiryDateChange) {
                    onEwayExpiryDateChange(val);
                  } else {
                    setLoads((prev) =>
                      prev.map((l) =>
                        l.id === load.id
                          ? { ...l, ewayExpiryDate: val, errors: { ...l.errors, ewayExpiryDate: "" } }
                          : l
                      )
                    );
                  }
                }}
                minDate={load.ewayStartDate}
                error={load.errors?.ewayExpiryDate}
                focus={!!load.errors?.ewayExpiryDate}
                id={`eway-end-${load.id}`}
                showTimeSelect={false}
                defaultTimeFix={true}
              />
            </div>
          </>
        )}
      </div>

      {/* ── Party + Location Row ───────────────────────────────────────────── */}
      <div className="load-form-row party-row">

        {/* Party */}
        <div className="form-field">
          <DropdownSelectButton
            label="Party"
            placeholder="Select Party *"
            selectTxt={load.party?.label || ""}
            crossIcon={!!load.party?.label}
            crossIconOnlick={() => update("party", null)}
            onClick={() =>
              setPartyModal({
                type: "party",
                action: true,
                name: "Party",
                data: load.party || {},
              })
            }
            onEditClick={onEditParty && load.party ? () => onEditParty(load.party) : undefined}
            error={!!errors.party}
            errorMessage={errors.party}
          />
        </div>

        {/* From Location */}
        <div className="form-field">
          <DropdownSelectButton
            label="From Location"
            placeholder="From Location *"
            selectTxt={
              load.fromLocation?.name
                ? `${load.fromLocation.name}${load.fromLocation.stateName ? `, ${load.fromLocation.stateName}` : ""}`
                : ""
            }
            crossIcon={!!(load.fromLocation?.label || load.fromLocation?.name)}
            crossIconOnlick={() => update("fromLocation", null)}
            onClick={() =>
              setFromModal({
                type: "fromLocation",
                action: true,
                name: "From Location",
                data: load.fromLocation || {},
              })
            }
            onEditClick={onEditFromLocation && load.fromLocation ? () => onEditFromLocation(load.fromLocation) : undefined}
            error={!!errors.fromLocation}
            errorMessage={errors.fromLocation}
          />
        </div>

        {/* To Location */}
        <div className="form-field">
          <DropdownSelectButton
            label="To Location"
            placeholder="To Location *"
            // selectTxt={load.toLocation?.label || load.toLocation?.name || ""}
            selectTxt={
              load.toLocation?.name
                ? `${load.toLocation.name}${load.toLocation.stateName ? `, ${load.toLocation.stateName}` : ""}`
                : ""
            }
            crossIcon={!!(load.toLocation?.label || load.toLocation?.name)}
            crossIconOnlick={() => update("toLocation", null)}
            onClick={() =>
              setToModal({
                type: "toLocation",
                action: true,
                name: "To Location",
                data: load.toLocation || {},
              })
            }
            onEditClick={onEditToLocation && load.toLocation ? () => onEditToLocation(load.toLocation) : undefined}
            error={!!errors.toLocation}
            errorMessage={errors.toLocation}
          />
        </div>

        {/* MLR Number */}
        <div className="form-field">
          <CommonInput
            placeholder="MLR Number"
            value={load.mlrNumber || ""}
            onChange={({ target: { value } }) => update("mlrNumber", value)}
            maxLength={12}
          />
        </div>

        {/* Invoice Number */}
        <div className="form-field">
          <CommonInput
            placeholder="Invoice Number"
            value={load.invoiceNumber || ""}
            onChange={({ target: { value } }) => update("invoiceNumber", value)}
            maxLength={12}
          />
        </div>
      </div>

      {/* ── Item Details Row ───────────────────────────────────────────────── */}
      <div className="load-form-row details-row">

        {/* Product Description */}
        <div className="form-field">
          <CommonInput
            type="text"
            placeholder="Description"
            value={load.productDescription || ""}
            maxLength={50}
            onChange={({ target: { value } }) => update("productDescription", value)}
             
          />
        </div>

        {/* Weight + weight_type */}
        <div className="form-field">
          <div style={{
            display: "flex", alignItems: "center",
            border: "1px solid #d1d5db", borderRadius: "6px",
            overflow: "hidden", background: "#fff",
          }}>
            <input
              type="number"
              placeholder="Weight"
              value={load.weight > 0 ? load.weight : ""}
              maxLength={8}
              onFocus={(e) => e.target.addEventListener("wheel", (e) => e.preventDefault(), { passive: false })}
              onKeyDown={(e) => handleKeyDown(e, "weight")}
             onChange={({ target: { value } }) => handleNumericInput("weight", value, 8)}
              style={{
                flex: 1, border: "none", outline: "none", boxShadow: "none",
                background: "transparent", padding: "8px 10px", fontSize: "13px",
                color: "#111827", minWidth: 0,
              }}
            />
            <select
              value={load.weight_type || 1}
              onChange={({ target: { value } }) => update("weight_type", +value)}
              style={{
                border: "none", borderLeft: "1px solid #e5e7eb", background: "#f9fafb",
                outline: "none", fontSize: "11px", color: "#374151",
                padding: "0 20px 0 6px", minHeight: "43px", minWidth: "52px",
                maxWidth: "64px", cursor: "pointer", appearance: "none",
                WebkitAppearance: "none",
                backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'%3E%3Cpath d='M1 1l4 4 4-4' stroke='%236b7280' stroke-width='1.5' fill='none' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E")`,
                backgroundRepeat: "no-repeat", backgroundPosition: "right 4px center",
              }}
            >
              {masterData?.material_weight_type_list?.map((el, idx) => (
                <option key={idx} value={el?.id}>{el?.name}</option>
              ))}
            </select>
          </div>
        </div>

        {/* Quantity + qty_type */}
        <div className="form-field">
          <div style={{
            display: "flex", alignItems: "center",
            border: "1px solid #d1d5db", borderRadius: "6px",
            overflow: "hidden", background: "#fff",
          }}>
            <input
              type="number"
              placeholder="QTY"
              value={load.quantity > 0 ? load.quantity : ""}
              maxLength={8}
              onFocus={(e) => e.target.addEventListener("wheel", (e) => e.preventDefault(), { passive: false })}
              onKeyDown={(e) => handleKeyDown(e, "quantity")}
             onChange={({ target: { value } }) => handleNumericInput("quantity", value, 8)}
              style={{
                flex: 1, border: "none", outline: "none", boxShadow: "none",
                background: "transparent", padding: "8px 10px", fontSize: "13px",
                color: "#111827", minWidth: 0,
              }}
            />
            <select
              value={load.qty_type || 1}
              onChange={({ target: { value } }) => update("qty_type", +value)}
              style={{
                border: "none", borderLeft: "1px solid #e5e7eb", background: "#f9fafb",
                outline: "none", fontSize: "11px", color: "#374151",
                padding: "0 20px 0 6px", minHeight: "43px", minWidth: "52px",
                maxWidth: "64px", cursor: "pointer", appearance: "none",
                WebkitAppearance: "none",
                backgroundImage: `url("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='10' height='6' viewBox='0 0 10 6'%3E%3Cpath d='M1 1l4 4 4-4' stroke='%236b7280' stroke-width='1.5' fill='none' stroke-linecap='round' stroke-linejoin='round'/%3E%3C/svg%3E")`,
                backgroundRepeat: "no-repeat", backgroundPosition: "right 4px center",
                borderRadius: 0,
              }}
            >
              {masterData?.material_qty_type_list?.map((el, idx) => (
                <option key={idx} value={el?.id}>{el?.name}</option>
              ))}
            </select>
          </div>
        </div>

        {/* Sales Value */}
        <div className="form-field">
          <CommonInput
            type="number"
            placeholder="Amount (₹)"
            value={load.salesValue > 0 ? load.salesValue : ""}
            maxLength={10}
            onFocus={(e) => e.target.addEventListener("wheel", (e) => e.preventDefault(), { passive: false })}
            onKeyDown={(e) => handleKeyDown(e, "salesValue")}
           onChange={({ target: { value } }) => handleNumericInput("salesValue", value, 10)}
          />
        </div>

        {/* KOT */}
        <div className="form-field">
          <CommonInput
            type="number"
            placeholder="KOT"
            value={load.kot > 0 ? load.kot : ""}
            maxLength={8}
            onFocus={(e) => e.target.addEventListener("wheel", (e) => e.preventDefault(), { passive: false })}
            onKeyDown={(e) => handleKeyDown(e, "kot")}
           onChange={({ target: { value } }) => handleNumericInput("kot", value, 8)}
          />
        </div>
      </div>

      {/* ── Modals ────────────────────────────────────────────────────────────── */}
      {partyModal?.action && createPortal(
        <DropdownSelectModal {...partyModalProps} />,
        document.body
      )}  
      {fromModal?.action && createPortal(
        <DropdownSelectModal {...fromModalProps} />,
        document.body
      )}
      {toModal?.action && createPortal(
        <DropdownSelectModal {...toModalProps} />,
        document.body
      )}
    </>
  );
};

export default LoadFormFields;